import Swiper from 'swiper/bundle'

export default () => {
    const reviewSwiper = new Swiper('.reviewsSwiper', {
        pagination: {
            el: '.swiper-pagination',
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })

    let prevButton = document.querySelector('#prev-button-wizard')
    let nextButton = document.querySelector('#next-button-wizard')
    let submitButton = document.querySelector('#submit-button-wizard')

    window.wizardSwiper = new Swiper('.wizardSwiper', {
        allowTouchMove: false,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '#next-button-wizard',
            prevEl: '#prev-button-wizard',
        },
    })

    let socialMediaInputs = {
        facebook: document.querySelector('input#facebook_name'),
        instagram: document.querySelector('input#instagram_name'),
        linkedin: document.querySelector('input#linkedin_name'),
    }

    wizardSwiper.on('slideChange', () => {
        nextButton.classList.add('swiper-button-disabled')
    })

    wizardSwiper.on('slideChangeTransitionEnd', () => {
        checkButtons()
    })
    
    document.querySelector('.wizardSwiper').querySelectorAll('input, textarea, select').forEach((input) => {
        input.addEventListener('change', checkButtons)
        input.addEventListener('keyup', checkButtons)
    })

    document.querySelectorAll('input#facebook, input#instagram, input#linkedin').forEach((input) => {
        input.addEventListener('change', (event) => {
            if (event.target.checked) {
                socialMediaInputs[event.target.id].parentElement.style.display = 'block'
                socialMediaInputs[event.target.id].removeAttribute('disabled')
            } else {
                socialMediaInputs[event.target.id].parentElement.style.display = 'none'
                socialMediaInputs[event.target.id].setAttribute('disabled', '')
            }
        })
    })

    /**
     * Prevent going to the next slide by using the tab key.
     */
    document.querySelector('.wizardSwiper').querySelectorAll('.swiper-slide').forEach((slide) => {
        let lastInputOfSlide = Array.from(slide.querySelectorAll('input, textarea, select')).pop()

        if (typeof lastInputOfSlide !== 'undefined') {
            slide.addEventListener('keydown', (event) => {
                if (event.keyCode === 9) {
                    let checkValue = document.activeElement.tagName.toLowerCase() === 'label' ? document.activeElement.getAttribute('for') : document.activeElement.id

                    if (lastInputOfSlide.id === checkValue) {
                        event.preventDefault()
                    }
                }
            })
        }
    })

    checkButtons()

    function checkButtons()
    {
        prevButton.style.display = [0, 1].includes(wizardSwiper.progress) ? 'none' : 'inline-flex'
        nextButton.style.display = [0.8, 1].includes(wizardSwiper.progress) ? 'none' : 'inline-flex'
        submitButton.style.display = [0.8].includes(wizardSwiper.progress) ? 'inline-flex' : 'none'

        if (canProceedToNextStep()) {
            nextButton.classList.remove('swiper-button-disabled')
            nextButton.removeAttribute('disabled')
        } else {
            nextButton.classList.add('swiper-button-disabled')
            nextButton.setAttribute('disabled', '')
        }
    }

    function canProceedToNextStep()
    {
        let canProceed = true
        let slide = document.querySelector('.wizardSwiper .swiper-slide-active')
        let maxChannelsMessage = document.querySelector('.wizardSwiper #max-channels-message')
        
        slide.querySelectorAll('input, textarea, select').forEach((input) => {
            if (input.type === 'checkbox' && input.hasAttribute('required')) {
                let amountChecked = 0
                
                slide.querySelectorAll('input[name="' + input.name + '"]').forEach((checkbox) => {
                    if (checkbox.checked) {
                        amountChecked++
                    }
                })

                if (amountChecked === 0) {
                    canProceed = false
                }
                
                if (input.getAttribute('name') === 'socials[]') {
                    if (amountChecked > 2) {
                        canProceed = false
                        maxChannelsMessage.style.display = 'block'
                    } else if (amountChecked > 0) {
                        maxChannelsMessage.style.display = 'none'
                    }
                }
            } else {
                if (!input.hasAttribute('disabled') && input.hasAttribute('required') && input.value === '') {
                    canProceed = false
                }

                if (input.type === 'email' && !(typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(input.value))) {
                    canProceed = false
                }
            }
        })

        return canProceed
    }
}
